import React from 'react';
import { Box, Typography, Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { UpArrowIcon, DownArrowIcon } from '../../Dashboard/Styles/arrows';

const EventsMetricCard = ({
  label,
  value,
  percentageChange,
  comparisonValue,
  tooltip,
  valuePrefix = '',
  formatValue,
  formatComparison,
}) => {
  const displayValue = formatValue ? formatValue(value) : value.toLocaleString();
  const hasComparison =
    percentageChange != null && comparisonValue != null && !Number.isNaN(Number(percentageChange));
  const isIncrease = hasComparison && percentageChange > 0;
  const trendColor = isIncrease ? '#34a853' : '#ea4335';
  const sign = isIncrease ? '+' : '-';

  const displayComparison =
    formatComparison?.(Math.abs(comparisonValue), isIncrease) ??
    `${sign}${Math.abs(comparisonValue).toLocaleString()}`;

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        borderRadius: 2,
        p: 2.5,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}
      >
        <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
          {label}
        </Typography>
        <Tooltip title={tooltip}>
          <IconButton size="small" sx={{ color: 'text.disabled', p: 0.25, mt: -0.25 }}>
            <InfoOutlinedIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', mb: hasComparison ? 1 : 0 }}>
        <Typography variant="h4" component="span" sx={{ fontWeight: 700, color: 'text.primary' }}>
          {valuePrefix}
          {displayValue}
        </Typography>
        {hasComparison && (
          <Box sx={{ display: 'flex', alignItems: 'center', ml: 1.5 }}>
            {isIncrease ? (
              <UpArrowIcon sx={{ fontSize: 22 }} />
            ) : (
              <DownArrowIcon sx={{ fontSize: 22 }} />
            )}
            <Typography
              variant="subtitle1"
              component="span"
              sx={{ color: trendColor, fontWeight: 700, ml: 0.5 }}
            >
              {sign}
              {Math.abs(percentageChange)}%
            </Typography>
          </Box>
        )}
      </Box>

      {hasComparison && (
        <Typography variant="body2" component="div">
          <Box component="span" sx={{ color: trendColor, fontWeight: 500 }}>
            {displayComparison}
          </Box>
          <Box component="span" sx={{ color: 'text.secondary', ml: 0.5 }}>
            Compared to last week
          </Box>
        </Typography>
      )}
    </Box>
  );
};

export default EventsMetricCard;
